var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',[_c('b-form-input',{ref:"input",attrs:{"value":_vm.value}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.onCopy}},[_vm._v("コピー")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }